import React from 'react';
import createImageAlt from 'presentation/utils/createImageAlt';
import urlLanguageParse from 'presentation/utils/urlLanguageParse';
import { Layout } from 'domain/constants/layout';
import { useCurrentLanguage } from 'domain/selectors/page';
import { Dimension } from 'domain/constants/dimension';

import { Image } from './Centerfold';
import { getClassNames, StyledRoot } from './Image.stylesheet';

export interface OuterProps {
  image: Image;
  layout: Layout;
}

export const PureImage = ({ image, layout }: OuterProps) => {
  const classNames = getClassNames({ layout });
  const currentLanguage = useCurrentLanguage();

  const alt = createImageAlt({ imageUrl: image.url });

  const imgSrc = urlLanguageParse(image.url, currentLanguage);

  // preserving image height uses contain, so the image always fits in
  // otherwise fill available width with cover
  const aspect = image.preserveDimension === Dimension.HEIGHT ? 'contain' : 'cover';

  return (
    <StyledRoot className={classNames.root} aspect={aspect} focus={image.focus} constrained={layout.constrainImage}>
      <img loading="lazy" src={imgSrc} alt={alt} className={classNames.image} />
    </StyledRoot>
  );
};

PureImage.displayName = 'CenterfoldImage';

export default PureImage;
